import { render } from "./CourseView.vue?vue&type=template&id=3f6b1db5&scoped=true"
import script from "./CourseView.vue?vue&type=script&lang=js"
export * from "./CourseView.vue?vue&type=script&lang=js"

import "./CourseView.vue?vue&type=style&index=0&id=3f6b1db5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6b1db5"]])

export default __exports__